import React, { Fragment, useState, useEffect } from 'react';
import DatePicker from 'react-date-picker';
import Select from 'react-select'
import AddExpense from './AddExpense';



const InputShift = () => {
    //Shift Attributes
    const [valid_client, setValid_client] = useState(true);
    const [client_id, setClient_id] = useState("");
    const [start_date, setStart_date] = useState(new Date());
    const [start_hours, setStart_hours] = useState("");
    const [start_minutes, setStart_minutes] = useState("");
    const [end_date, setEnd_date] = useState(new Date());
    const [end_hours, setEnd_hours] = useState("");
    const [end_minutes, setEnd_minutes] = useState("");
    const [expenses, setExpenses] = useState([]);
    const [m_travelled, setM_travelled] = useState(0);
    const [description, setDescription] = useState("");
    const [client_list, setClient_list] = useState([]);

    const [client_description, setClient_description] = useState("");
    const [duration, setDuration] = useState(0);

    const [date_bad, setDate_bad] = useState(false);





    const getClients = async () => {
        const response = await fetch("https://www.beyondcommunityaccess.com/clients", {
            method: "GET",
            headers: { "Content-Type": "application/json", token: localStorage.token },
        })
        const jsonData = await response.json();

        jsonData.rows.map(item => {
            item.label = item.name
            item.value = item.client_id
            delete item.name;
            delete item.client_id;
            return item;
        })

        setClient_list(jsonData.rows)
    }

    const onSubmitForm = async (e) => {
        e.preventDefault();
        try {

            var date_start = new Date(start_date.toDateString());
            var date_end = new Date(end_date.toDateString());

            date_start.setHours(start_hours);
            date_start.setMinutes(start_minutes);

            date_end.setHours(end_hours);
            date_end.setMinutes(end_minutes);
            var start = date_start.getTime()
            var end = date_end.getTime()

            if (start >= end) {
                setDate_bad(true);
                return
            }
            setDate_bad(false);



            const body = { client_id, start, end, expenses, m_travelled, description };
            if (client_id === "") {
                setValid_client(false);
                return
            }
            setValid_client(true);
            await fetch("https://www.beyondcommunityaccess.com/shifts/new", {
                method: "POST",
                headers: { "Content-Type": "application/json", token: localStorage.token },
                body: JSON.stringify(body)
            })

            window.location = "/ListShifts";
        } catch (err) {
            console.error("Cannot input shift")
            console.error(err.message);
        }
    }

    function trimExpenses(index) {
        setExpenses(expenses.filter((_, i) => i !== index));
    }

    const getDuration = async () => {
        if (start_hours !== "" && start_minutes !== "" && end_hours !== "" && end_minutes !== "") {
            var date_start = new Date(start_date.toDateString());
            var date_end = new Date(end_date.toDateString());

            date_start.setHours(start_hours);
            date_start.setMinutes(start_minutes);

            date_end.setHours(end_hours);
            date_end.setMinutes(end_minutes);
            var num_dif = date_end.getTime() - date_start.getTime()
            if (isNaN(num_dif)) {
                setDuration("Too Big")
                return
            }
            if (num_dif < 0) {
                setDuration("End date is earlier than the start date")
                return
            }
            var hours = Math.floor(num_dif / 3600000);
            var minutes = num_dif / 60000 % 60;
            if (hours < 10) {
                hours = '0' + hours
            }
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            setDuration(hours + ":" + minutes)
        } else {
            setDuration("");
        }
    }
    function roundKM() {
        setM_travelled(Math.floor(m_travelled))
    }

    useEffect(() => {
        getClients();
    }, [])

    useEffect(() => {
        getDuration();
    }, [start_hours, start_minutes, end_hours, end_minutes])

    useEffect(() => {
        roundKM();
    }, [m_travelled])
    return (
        <Fragment>
            <div className="container">
                <h1 className="text-center mt-5">Input Shift</h1>
                <form className="mt-5 text-center" onSubmit={onSubmitForm}>
                    <h6>Client Name</h6>
                    <Select isClearable={true} isSearchable={true} options={client_list} onChange={e => { if (e !== null) { setClient_id(e.value); setClient_description(client_list.find(client => client.value === e.value).client_description) } else { setClient_id(""); setClient_description("") };}} />
                    {!valid_client && <h6 className="mt-2 text-danger" >Invalid Client</h6>}
                    {client_description !== "" && <h6 className="mt-2" >Description</h6>}
                    {client_description !== "" && <p className="mt-2" >{client_description}</p>}

                    <h6 className="mt-2">Start Date</h6>
                    <DatePicker onChange={setStart_date} value={start_date} />
                    <h6 className="mt-2">Start Time (24 Hour Time)</h6>
                    <input required type="number" min="0" max="23" placeholder="hr" onChange={e => setStart_hours(e.target.value)} value={start_hours} />
                    <input required type="number" min="0" max="59" placeholder="min" onChange={e => setStart_minutes(e.target.value)} value={start_minutes} />

                    <h6 className="mt-2">End Date</h6>
                    <DatePicker onChange={setEnd_date} value={end_date} />
                    <h6 className="mt-2">End Time (24 Hour Time)</h6>
                    <input required type="number" min="0" max="23" placeholder="hr" onChange={e => setEnd_hours(e.target.value)} value={end_hours} />
                    <input required type="number" min="0" max="59" placeholder="min" onChange={e => setEnd_minutes(e.target.value)} value={end_minutes} />

                    {duration !== "" && <p>Duration: {duration}</p>}


                    <h6 className="mt-2">Expenses: {expenses.length}</h6>
                    {expenses.map((expense, index) => {
                        var contains_proof = ((expense.image) ? "Attatched" : "N/A");
                        return <div key={"expense_id_inp_shift" + index} className="d-flex justify-content-center">

                            <p className="mt-2" >Cost: {expense.cost / 100} description: {expense.description} proof: {contains_proof}</p>
                            <button type="button" className="btn btn-warning ml-2 mb-2" onClick={() => trimExpenses(index)}>Delete</button>
                        </div>
                    })}
                    <AddExpense expenses={expenses} setExpenses={setExpenses}></AddExpense>


                    <h6 className="mt-2">KM Travelled (whole number)</h6>
                    <input required type="number" className="form-control" value={m_travelled} onChange={e => setM_travelled(e.target.value)} />

                    <h6 className="mt-2">Description</h6>
                    <input required type="text" className="form-control" value={description} onChange={e => setDescription(e.target.value)} />

                    <button className="btn btn-success mt-2">Add</button>
                    {date_bad && <h6 className="mt-2 text-danger" >End time before start time</h6>}

                </form>
            </div>
        </Fragment>
    )
}

export default InputShift;


